import LeftPanel from './LeftPanel.vue'

export default LeftPanel;
